import React from "react";
import { d3, gettext, cropr } from "../../adapter";
import moment from "moment";
import clone from "lodash/clone";
import IrrigationDepthChart from "../../charts/irrigationDepthChart";
import sensorActions from "../../actions/sensorActions";

class DepthChart extends React.Component {
  constructor(props) {
    super(props);

    this.chartRef = React.createRef();
    // @TODO: little hack, should be solved with immutable object / state
    this.lastRefillPoint = null;
    this.lastFieldCapacity = null;
    this.lastScale = null;
    this.lastDomain = null;

    var minimumDaysOfMeasurement = 0.5;
    var domainLength = moment(this.props.domain[1]).diff(moment(this.props.domain[0]), "days");
    this.shouldChartShow =
      this.props.sensor.measurements.moisture[this.props.depth].length > 1 &&
      domainLength > minimumDaysOfMeasurement;
  }

  componentDidMount() {
    var _this = this;
    var elDepth = this.chartRef.current;
    var sensorDepth = this.props.sensor.depths[this.props.depth];

    // Calculate the min dragger distance of 1 on scale
    var minDraggerDistance =
      sensorDepth.originalScale /
      (sensorDepth.originalFieldCapacity - sensorDepth.originalRefillPoint);
    if (this.shouldChartShow) {
      this.chart = new IrrigationDepthChart(
        {
          id: "depth-chart-" + this.props.depth,
          height: 200,
          depth: this.props.depth,
          editable: true,
          showLegend: this.props.showLegend,
          minDraggerDistance: minDraggerDistance,
          class: "chart water-depth",
          width: parseInt(d3.select(elDepth).style("width"), 10), // With of the container element
        },
        _this.getChartState(_this.props),
        this.props.dispatch
      );

      this.chart.init(elDepth);

      this.lastRefillPoint = sensorDepth.refillPoint;
      this.lastFieldCapacity = sensorDepth.fieldCapacity;
      this.lastScale = sensorDepth.scale;
      this.lastDomain = clone(_this.props.domain);

      window.addEventListener("resize", () => {
        this.handleResize();
      });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    var sensorDepth = nextProps.sensor.depths[this.props.depth];

    // Only update if something changed here
    if (
      this.lastScale !== sensorDepth.scale ||
      this.lastRefillPoint !== sensorDepth.refillPoint ||
      this.lastFieldCapacity !== sensorDepth.fieldCapacity ||
      this.lastDomain[0] !== nextProps.domain[0] ||
      this.lastDomain[0] !== nextProps.domain[0]
    ) {
      if (this.chart) {
        this.chart.update(this.getChartState(nextProps, nextState));
      }

      // Update the values
      this.lastScale = sensorDepth.scale;
      this.lastRefillPoint = sensorDepth.refillPoint;
      this.lastFieldCapacity = sensorDepth.fieldCapacity;
      this.lastDomain = clone(nextProps.domain);
      return true;
    }

    return false;
  }

  handleResize() {
    var elDepth = this.chartRef.current;
    if (elDepth) this.chart.resize(parseInt(d3.select(elDepth).style("width"), 10), false);
  }

  getChartState(props) {
    return {
      sensor: props.sensor,
      measurements: props.sensor.measurements,
      lastDataPoint: props.lastDataPoint,
      domain: props.domain,
    };
  }

  render() {
    const { sensor, depth } = this.props;
    var errors = sensor.errors;

    var message = (
      <div className="message">
        {gettext("This depth lacks sufficient measurements for displaying a graph.")}
      </div>
    );

    var chart = "";
    var depthValue = sensor.depths[depth].scale;

    let localizedDepthValue = depthValue;
    if (cropr.l10n.unit_precipitation === "in") {
      localizedDepthValue = localizedDepthValue / 25.4;
    }
    localizedDepthValue = Math.round(localizedDepthValue * 100) / 100;

    if (this.shouldChartShow) {
      chart = <div className="chart-depth" ref={this.chartRef} />;
      message = "";
    }
    return (
      <li>
        <div className="chart-depth-wrapper">
          {chart}
          <div className="chart-depth--amount">
            <div className="chart-depth--amount--content">
              {cropr.l10n_utils.depth_to_l10n(depth)} {cropr.l10n.unit_depth_display}
            </div>
          </div>
          <div
            className={
              errors.scale[depth] ? "chart-depth--stats form--error" : "chart-depth--stats"
            }
          >
            <div className="has-label-styles has-normal-weight">
              {gettext("Available soil moisture between set points in {{unit}}.").replace(
                "{{unit}}",
                cropr.l10n.unit_precipitation_display
              )}
            </div>
            <div className="input-plus-minus ">
              {message}
              <input
                type="number"
                step="0.1"
                name="depth"
                className="input-plus-minus--amount"
                value={localizedDepthValue}
                onChange={(event) => {
                  let value = event.target.value;
                  // The user fills in the value using their locatisation, but
                  // the value must be saved in mm. So if the unit is in
                  // inch convert to millimeters.
                  if (cropr.l10n.unit_precipitation === "in") {
                    value = value * 25.4;
                  }

                  this.props.dispatch(sensorActions.updateScale(this.props.depth, value));
                }}
              />
              {errors.scale[depth] === "required" ? (
                <ul className="form--errors">
                  <li className="error--message">
                    {gettext("Available soil moisture is not allowed to be empty.")}
                  </li>
                </ul>
              ) : (
                ""
              )}
              {errors.scale[depth] === "invalid" ? (
                <ul className="form--errors">
                  <li className="error--message">
                    {gettext("Enter millimeters without fractional digits.")}
                  </li>
                </ul>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </li>
    );
  }
}

export default DepthChart;
